import { ConfigProvider, Empty } from 'antd'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './containers/App'
import store from './store'
import ruRu from 'antd/lib/locale/ru_RU'

if (process.env.NODE_ENV !== 'production') {
  console.log('===== Development =====') // eslint-disable-line
} else {
  console.log('===== Production =====') // eslint-disable-line
}

const customizeRenderEmpty = () => (
  <div style={{ textAlign: 'center' }}>
    <p>Нет данных</p>
  </div>
)

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider renderEmpty={customizeRenderEmpty} locale={ruRu}>
      <App />
    </ConfigProvider>
  </Provider>,
  document.getElementById('app'),
)

// Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./containers/App', () => {
    const NextApp = require('./containers/App').default // eslint-disable-line
    ReactDOM.render(
      <Provider store={store}>
        <NextApp />
      </Provider>,
      document.getElementById('app'),
    )
  })
}



// WEBPACK FOOTER //
// src/index.js